const KEY = 'nomadme_return_to';

export function saveReturnTo(path: string): void {
  localStorage.setItem(KEY, path);
}

export function consumeReturnTo(): string | null {
  const v = localStorage.getItem(KEY);
  if (v) localStorage.removeItem(KEY);
  return v;
}
